import { Input, Modal, Typography } from 'antd'
import React from 'react'
import './aopsCommonModal.scss'

const { Text } = Typography
const { TextArea } = Input

const AopsCommonModalLayout = ({
  open = false,
  onClose,
  title,
  children,
  width = '80%',
  style = {},
  contentStyle = {},
  contentClassName = '',
  zIndex,
}) => {
  const windowWidth = window.innerWidth
  return (
    <Modal
      open={open}
      onCancel={onClose}
      footer={null}
      width={width || windowWidth * 0.8}
      centered
      // scrollBody={false}
      // className="aops-common-modal-modal"
      closeIcon={
        <>
          <div style={{ marginTop: '14px', height: '55px' }} />
          <img
            src="/assets/icon/aops/close-x-icon.svg"
            alt="close"
            // style={{ marginTop: '14px' }}
          />
        </>
      }
      className="approval-popup-modal"
      style={{ width: width, ...style }}
      zIndex={zIndex}
    >
      <div className="approval-popup">
        <div className="popup-header">
          <h2 className="popup-title">{title}</h2>
        </div>
        <div
          className={`approval-popup-content ${contentClassName}`.trim()}
          style={{ ...contentStyle }}
        >
          {children}
        </div>

        {/* 버튼 */}
      </div>
    </Modal>
  )
}

export default AopsCommonModalLayout
